<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <multiselect v-model="selected" :custom-label="getLabel" track-by="_id" :placeholder="$t(placeHolder)"
                 :options="items" :multiple="multiple" :disabled="disabled" :internal-search="false"
                 @input="onInput" @search-change="search">
      <template v-slot:noResult>
        {{ $t('notFoundSearch') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('notFoundSearch') }}
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import _ from 'lodash';
import list from '@/mixins/List';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  props: {
    model: Object,
    attribute: {
      type: String
    },
    label: String,
    errors: Array,
    placeHolder: {
      type: String,
      default: 'select'
    },
    multiple: Boolean,
    disabled: Boolean,
    filter: Object,
    isFilter: Boolean
  },
  components: {Multiselect},
  mixins: [list],
  data() {
    return {
      selected: null,
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: 'social-network-account',
      autoLoad: false,
      defaultFilterFormModel: {
        keyword: '',
      },
      focused: false,
      changeTrigger: true,
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        if (val[this.attribute] != null) {
          if (this.changeTrigger) {
            this.loadSelected();
          }
          this.changeTrigger = true;
        } else {
          this.selected = null;
        }
      }, deep: true
    },
    filter: {
      handler() {
        this.load();
      }, deep: true
    },
    selected(val) {
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = val;
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s._id);
      } else {
        this.model[this.attribute] = val._id;
      }
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    load: function () {
      let loader = this.$loading.show();
      this.loading = true;
      this.listLoading = true;
      let filter = Object.assign({}, this.filterFormModel);
      if (this.filter) {
        filter = Object.assign(this.filter, filter);
      }
      this.$service.get(this.service, {
        params: filter
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
        this.listLoading = false;
        if(this.afterLoad){
          this.afterLoad();
        }
      });
    },
    onInput() {
      let val = this.selected;
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = val;
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s._id);
      } else {
        this.model[this.attribute] = val._id;
      }
      this.$emit('change');
    },
    getLabel({name}) {
      return `${name}`;
    },
    search: _.debounce(function (event) {
      this.filterFormModel.keyword = event;
      this.filterFormModel.page = 1;
      this.load();
    }, 250),
    loadSelected() {
      if (this.model[this.attribute]) {
        let ids;
        if (this.multiple) {
          ids = this.model[this.attribute].join(',');
        } else {
          ids = this.model[this.attribute];
        }
        if (ids) {
          this.$bgService.get(this.service, {
            params: {page: 1, pageSize: 100, ids: ids}
          }).then(response => {
            if (this.multiple) {
              this.selected = response.data.docs;
            } else if (response.data.docs.length) {
              let rs = response.data.docs;
              this.selected = rs.find(kq => kq._id === this.model[this.attribute]);
            }
          });
        }
      }
    }
  },
  mounted() {
    this.selected = null;
    this.loadSelected();
    this.load();
  },
  i18n: {
    messages: {
      en: {
        select: 'Select Social Account',
      },
      vi: {
        select: 'Chọn tài khoản mạng xã hội',
      }
    }
  }
}
</script>